//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { useDispatch } from 'react-redux';
import M_NOT_BASIC_03 from './M_NOT_BASIC_03';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSearch5,
  useSearch6,
} from './M_NOT_BASIC_03_Query';
import { useBackStack } from '../../../Hooks/back/useBackStack';
import { useNavigate } from 'react-router-dom';
//#endregion

export default function M_NOT_BASIC_03F() {
  //#region 변수
  const { id } = useParams();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [rowData1, setRowData1] = useState(null); // 게시글 상세 데이터
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1); // 100% 화면 너비로 시작
  const [fileInfo, setFileInfo] = useState(null);
  const [postList, setPostList] = useState([]);
  const [currentPostIndex, setCurrentPostIndex] = useState(0);
  const blobUrlRef = useRef(null);
  //#endregion

  // 스택형 뒤로가기로 변경: 공지 상세에서는 목록으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/M_Notice'),
  });

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('공지 사항'));
    dispatch(CommonActions.setActiveStep(1));
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
        blobUrlRef.current = null;
      }
    };
  }, [dispatch]);

  useEffect(() => {
    if (!id || !userInfo?.coCd) return;

    // 게시물 목록 가져오기
    loadPostList();

    // 페이지 번호 초기화
    setPageNumber(1);

    if (id.startsWith('P')) {
      Search2({ ChaebunNo: id.slice(1) });
    } else if (id.startsWith('E')) {
      Search6({ ChaebunNo: id.slice(1) });
    } else {
      Search1({ ChaebunNo: id.slice(1) });
    }
  }, [id, userInfo]);

  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1); // 화면 크기 바뀔 때 다시 계산
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!rowData1) return;

    // 1) DB 파일이 있으면 fileInfo 만들기
    const dbFile = getFileInfo(rowData1);
    if (dbFile) {
      setFileInfo(dbFile);
    }
    // 2) 파일이 없으면 → 리포트 요청
    else {
      generateReport(rowData1);
    }
  }, [rowData1]);

  //#region 조회
  // 구분 상세 조회(chaebun : 채번)
  const { run: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows[0]);
    },
  });
  // 구분 상세 조회(chaebun : 채번)
  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      const transformedPosts = Commons.InsertNumber(rows || []).map((item) => ({
        ...item,
        prefix: 'P',
      }));

      setRowData1(transformedPosts[0]);
    },
  });

  // 비상대응메뉴얼 상세 조회(chaebun : 채번)
  const { run: Search6 } = useSearch6({
    onSuccess: (rows) => {
      const transformed = Commons.InsertNumber(rows || []).map((item) => ({
        ...item,
        prefix: 'E',
        title: item?.title?.trim?.() ? item.title : '비상대응메뉴얼',
        chaebun: item?.chaebun ?? item?.Chaebun,
        filePath: item?.filePath ?? item?.FilePath,
        saveName: item?.saveName ?? item?.SaveName,
        createId: item?.createId ?? item?.CreateId,
        updateDate: item?.updateDate ?? item?.UpdateDate,
      }));
      setRowData1(transformed[0]);
    },
  });

  // 게시글 조회
  const { runAsync: Search3Async } = useSearch3();

  // 안전보건경영방침 조회
  const { runAsync: Search4Async } = useSearch4();

  // 비상대응메뉴얼(비상조치계획) 목록 조회
  const { runAsync: Search5Async } = useSearch5();
  //#endregion
  //#region 나머지 함수
  // 게시물 목록 가져오기
  const loadPostList = async () => {
    if (!userInfo?.coCd) return;

    try {
      const [posts, policies, manuals] = await Promise.all([
        Search3Async(),
        Search4Async(),
        Search5Async(),
      ]);

      const transformedPosts = Commons.InsertNumber(posts || []).map(
        (item) => ({
          ...item,
          prefix: 'N',
        })
      );

      const polData = policies?.[0];
      const transformedPolicies = polData
        ? [
            {
              ...polData,
              prefix: 'P',
              name: polData.name?.trim() ? polData.name : '안전보건경영방침',
            },
          ]
        : [];

      const transformedManuals = Commons.InsertNumber(manuals || []).map(
        (item) => ({
          ...item,
          prefix: 'E',
          title: item?.title?.trim?.() ? item.title : '비상대응메뉴얼',
          chaebun: item?.chaebun ?? item?.Chaebun,
          filePath: item?.filePath ?? item?.FilePath,
          saveName: item?.saveName ?? item?.SaveName,
          createId: item?.createId ?? item?.CreateId,
          updateDate: item?.updateDate ?? item?.UpdateDate,
        })
      );

      const allPosts = [
        ...transformedPolicies,
        ...transformedManuals,
        ...transformedPosts,
      ];
      setPostList(allPosts);

      const currentIndex = allPosts.findIndex((post) => {
        const postId = `${post.prefix}${post.chaebunNo || post.chaebun}`;
        return postId === id;
      });
      setCurrentPostIndex(currentIndex >= 0 ? currentIndex : 0);
    } catch (e) {
      console.error('게시물 목록 로드 실패:', e);
    }
  };

  // PDF 가져오기
  function getFileInfo(rowData1) {
    if (!rowData1) return null;
    const filePath = rowData1?.previewFilePath || rowData1?.filePath;
    const fileName = rowData1?.saveName;
    if (!filePath || !fileName) return null;

    const ext = fileName.split('.').pop()?.toLowerCase();
    const fullUrl = Global.file.useUrl + 'files/' + Commons.EncodeUrl(filePath);
    const pdfUrl = ext === 'hwp' ? fullUrl.replace(/\.hwp$/i, '.pdf') : fullUrl;

    return { ext, url: pdfUrl };
  }
  const generateReport = async (rowData) => {
    try {
      const printData = {
        FileName: 'POL_BASIC_01',
        HeaderData: JSON.stringify(rowData),
      };

      const response = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      if (!response?.data) throw new Error('PDF 응답 없음');

      const blob = new Blob([response.data], { type: 'application/pdf' });
      if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current);
      const url = URL.createObjectURL(blob);
      blobUrlRef.current = url;
      setFileInfo({ ext: 'pdf', url });
    } catch (err) {
      console.error('리포트 생성 실패:', err);
      dispatch(showSnackbar({ message: err.message, type: 'error' }));
    }
  };
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    } else {
      // 첫 번째 페이지에서 이전 버튼 클릭 시
      if (currentPostIndex > 0) {
        // 이전 게시물로 이동
        const prevPost = postList[currentPostIndex - 1];
        const prevPostId = `${prevPost.prefix}${
          prevPost.chaebunNo || prevPost.chaebun
        }`;
        navigate(`/M_Post/detail/${prevPostId}`);
      } else {
        // 첫 번째 게시물의 첫 번째 페이지면 리스트로 이동
        navigate('/M_Notice');
      }
    }
  };
  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    } else {
      // 마지막 페이지에서 다음 버튼 클릭 시
      if (currentPostIndex < postList.length - 1) {
        // 다음 게시물로 이동
        const nextPost = postList[currentPostIndex + 1];
        const nextPostId = `${nextPost.prefix}${
          nextPost.chaebunNo || nextPost.chaebun
        }`;
        navigate(`/M_Post/detail/${nextPostId}`);
      }
      // 마지막 게시물의 마지막 페이지면 아무것도 하지 않음 (버튼 비활성화)
    }
  };
  //#endregion

  return (
    <div>
      <M_NOT_BASIC_03
        rowData1={rowData1}
        goToPrevPage={goToPrevPage}
        goToNextPage={goToNextPage}
        pageNumber={pageNumber}
        numPages={numPages}
        pageWidth={pageWidth}
        onDocumentLoadSuccess={onDocumentLoadSuccess}
        fileInfo={fileInfo}
        isLastPost={currentPostIndex === postList.length - 1}
        isLastPage={pageNumber === numPages}
      />
    </div>
  );
}
